import React from "react";
import Slider from "react-slick";

const testimonials = [
  {
    name: "Mr. Arjun Verma",
    image: "/img/profiles/avatar-02.jpg",
    rating: 5,
    text: "Excellent service! The cab arrived on time and the driver was very polite. My journey was smooth and comfortable. Highly recommended SRS Cab Service."
  },
  {
    name: "Miss. Priya Sharma",
    image: "/img/profiles/avatar-03.jpg",
    rating: 5,
    text: "Very affordable and reliable service. Booking was easy and the car was clean. I felt safe traveling alone. Will definitely use again."
  },
  {
    name: "Mr. Rakesh Patel",
    image: "/img/profiles/avatar-04.jpg",
    rating: 5,
    text: "I booked an outstation trip and the experience was great. Driver was experienced and the ride was comfortable throughout the journey."
  },
  {
    name: "Miss. Neha Tiwari",
    image: "/img/profiles/avatar-06.jpg",
    rating: 5,
    text: "SRS Cab Service is very professional. On-time pickup, smooth ride, and good customer support. Highly satisfied with the service."
  },
  {
    name: "Mr. Sandeep Singh",
    image: "/img/profiles/avatar-07.jpg",
    rating: 5,
    text: "Best cab service in the area. Pricing is transparent and there are no hidden charges. Great experience overall."
  },
];

const AboutTestimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 2, // Desktop view
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024, // Tablet view
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600, // Mobile view
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="section about-testimonial testimonials-section">
      <div className="container">
        {/* Heading */}
        <div className="section-heading" data-aos="fade-down">
          <h2 className="title text-white">What People say about us?</h2>
          {/* <p className="description text-white">
            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
          </p> */}
        </div>

        {/* Slider */}
        <Slider {...settings} className="about-testimonials testimonial-group mb-0">
          {testimonials.map((testimonial, index) => (
            <div className="testimonial-item d-flex" key={index}>
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="quotes-head"></div>
                  <div className="review-box">
                    <div className="review-profile">
                      {/* <div className="review-img">
                        <img
                          src={testimonial.image}
                          className="img-fluid"
                          alt={testimonial.name}
                        />
                      </div> */}
                    </div>
                    <div className="review-details">
                      <h6>{testimonial.name}</h6>
                      <div className="list-rating">
                        <div className="list-rating-star">
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <i className="fas fa-star filled" key={i}></i>
                          ))}
                        </div>
                        <p>
                          <span>({testimonial.rating}.0)</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <p>{testimonial.text}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default AboutTestimonials;